import { render } from "./pageTop.vue?vue&type=template&id=4a5b3f2d&scoped=true"
import script from "./pageTop.vue?vue&type=script&lang=js"
export * from "./pageTop.vue?vue&type=script&lang=js"

import "./pageTop.vue?vue&type=style&index=0&id=4a5b3f2d&scoped=true&lang=css"

import exportComponent from "D:\\web\\dmsm\\dmsm-pages\\cloud\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5b3f2d"]])

export default __exports__